import React, { Component, ReactNode } from "react";

interface Props { children: ReactNode; label?: string }
interface State { hasError: boolean; message?: string }

export class TabErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message };
  }

  componentDidCatch(error: Error) {
    console.error("TabErrorBoundary:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="glass p-8 rounded-2xl text-center space-y-3">
          <p className="text-sm text-muted-foreground">
            Não foi possível carregar esta aba no momento.
          </p>
          {this.state.message && (
            <p className="text-xs text-muted-foreground/70">{this.state.message}</p>
          )}
          <button
            className="text-xs underline text-primary"
            onClick={() => this.setState({ hasError: false, message: undefined })}
          >
            Tentar novamente
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}